import React from "react";

export const Informations = () => <div>Informations</div>;
